module.exports = __webpack_public_path__ + "img/category-fill.4942bcf3.svg";